<template>
    <Layout>
        <div class="sticky-header">
            <div class="row">
                <div class="col-lg-12 col-sm-12">
                    <h4 class="header-title pb-3">
                        <a @click="$router.push('/recobro-menu')" class="ml-2 cursor-pointer">
                            <i class="fa fa-arrow-left"></i></a>
                        <span class="ml-3">Crear Recobro</span>
                    </h4>
                    <div class="m-b-30 card-container">
                        <div class="card-body">
                            <div>
                                <!--ramo: 91,
                                reclamo: '',
                                monto: '',
                                numeroPagos: '',
                                fechainicio: '',
                                frecuencia: '',-->
                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <div class="form-group">
                                            <span class="mb-2">Seleccione Ramo</span>
                                            <select v-model="ramo" class="form-control">
                                                <option value="91" selected>91 - Vehiculos</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="form-group text-left">
                                            <label class="mb-1 fw-bold">Número de reclamo</label>
                                            <input type="tel" class="form-control" v-model="reclamo">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="form-group text-left">
                                            <label class="mb-1 fw-bold">Monto</label>
                                            <input type="tel" class="form-control" v-model="monto" :disabled="notaTecnica">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="form-group text-left">
                                            <span class="mb-2">Número de pagos</span>
                                            <select v-model="numeroPagos" class="form-control" :disabled="numeroDisabled || notaTecnica">
                                                <option value="1" selected>1 Pago</option>
                                                <option value="2" selected>2 Pagos</option>
                                                <option value="3" selected>3 Pagos</option>
                                                <option value="6" selected>4 Pagos</option>
                                                <option value="12" selected>12 Pagos</option>
                                                <option value="16" selected>16 Pagos</option>
                                                <option value="18" selected>18 Pagos</option>
                                                <option value="72" selected>72 Pagos</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="form-group text-left">
                                            <label class="mb-1 fw-bold">Fecha de inicio</label>
                                            <input type="date" class="form-control" v-model="fechainicio">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <span class="mb-2">Frecuencia</span>
                                        <select v-model="frecuencia" class="form-control">
                                            <option value="W" selected>Semanal</option>
                                            <option value="Q" selected>Quincenal</option>
                                            <option value="M" selected>Mensual</option>
                                            <option value="B" selected>Bimensual</option>
                                            <option value="T" selected>Trimestral</option>
                                            <option value="S" selected>Semestral</option>
                                            <option value="A" selected>Anual</option>
                                        </select>
                                    </div>
                                    <div class="col-12 col-md-6" v-if="Object.keys(descuentos).length > 0">
                                        <div class="form-group text-left">
                                            <span class="mb-2">Descuentos</span>
                                            <select v-model="descuento" class="form-control">
                                                <option :value="item.monto" v-for="item in descuentos">{{item.descripcion}} - {{item.monto}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-right mt-4">
                                    <button @click="crearRecobro" type="button" class="btn btn-primary btn__crear">Crear Recobro</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>

import Layout from "../../../global/components/Layout";
import API from "src/core/Api";
import Tools from "src/core/Tools";
import Numbro from "numbro";
import dayjs from "dayjs";
import {store} from "src/store";
import Pago from "src/modules/pos/views/Pago";
import InicioPago from "src/modules/pos/views/components/InicioPago";


export default {
    props: {},
    components: {
        Pago,
        //TimelineChart,
        Layout,
        //Toster,
        InicioPago
    },
    data() {
        return {
            Valid: {},

            ramo: 91,
            reclamo: '',
            monto: '',
            montoOriginal: 0,
            numeroPagos: '1',
            numeroDisabled: false,
            fechainicio: '',
            frecuencia: 'M',

            // creacion a partir de nota tecnica
            notaTecnica: false,
            descuento: 0,
            descuentos: {},
        };
    },
    watch: {
        // whenever question changes, this function will run
        descuento: function (monto) {
            this.monto = monto;

            if (parseFloat(this.montoOriginal) > parseFloat(monto)) {
                this.numeroPagos = 1;
                this.numeroDisabled = true;
            }
            else {
                this.numeroDisabled = false;
            }
        }
    },
    mounted() {
        const today = new Date();
        const yyyy = today.getFullYear();
        let mm = today.getMonth() + 1; // Months start at 0!
        let dd = today.getDate();
        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;
        this.fechainicio = dd + '/' + mm + '/' + yyyy;

        let params = new URLSearchParams(document.location.search);
        let notaTecnica = params.get("nt");
        let monto = params.get("m");
        let descuentos = params.get("d");
        let reclamo = params.get("r");

        if (notaTecnica && parseInt(notaTecnica) === 0) {
            this.monto = monto;
        }
        else {
            this.monto = monto;
            this.notaTecnica = true;
        }

        if (descuentos && descuentos !== '0') {
            descuentos = window.atob(descuentos);
            descuentos = JSON.parse(descuentos);
            this.descuentos = descuentos.descuentos;
        }
        this.reclamo = (reclamo !== '') ? reclamo : '';
        this.montoOriginal = this.monto;
    },
    methods: {
        Numbro,
        dayjs,
        crearRecobro() {

            const self = this;
            this.recobros = {};

            if (confirm('¿Se creará un recobro, desea continuar?')) {

                store.dispatch('coreShowLoading');

                API.send('POST', 'recobro/crear', {
                        ramo: self.ramo,
                        reclamo: self.reclamo,
                        monto: self.monto,
                        numeroPagos: self.numeroPagos,
                        fechainicio: self.fechainicio,
                        frecuencia: self.frecuencia,
                    },
                    function (response) {
                        store.dispatch('coreHideLoading');

                        if (typeof response.status !== 'undefined') {

                            if (response.status) {
                                const recobro = parseInt(response.data);

                                if (recobro > 0) {
                                    self.$router.push('/recobro/recobro/'+recobro+'/Q/91');
                                }
                                else {
                                    alert(response.msg)
                                }
                            }
                            else {
                                alert(response.msg);
                            }
                        }
                        else {
                            alert(response.msg);
                        }
                    },
                    function () {
                        store.dispatch('coreHideLoading');
                        alert('Error al realizar operación, por favor intente de nuevo');
                    })
            }
        },
    },
};
</script>
